export class WFEVendorAccountResultDto {
    id: number; // Vendor account id
    accountNumber: string;
    description: string;
    active: boolean; // 	Indicates if the vendor account is active
    eftActive: boolean;
}
